/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { FitMeterCircle } from './FitMeterCircle';
import { SizedMeterCircle } from './SizedMeterCircle';
import { MeterProps } from './meterCircle.types';

/**
 * A Meter circle displays information graphically in a circular bar, highlighting a specific metric value's progress in relation to its min, max, or thresholds.
 */
export function MeterCircle({
  size,
  max = 100,
  min = 0,
  value = 0,
  step = 1,
  startAngle = 90,
  angleExtent = 360,
  isTrackRendered = true,
  thresholdDisplay = 'all',
  indicatorSize = 1,
  isReadonly,
  ...props
}: MeterProps) {
  if (size === 'fit') {
    return (
      <FitMeterCircle
        isReadonly={isReadonly}
        min={min}
        value={value}
        max={max}
        step={step}
        startAngle={startAngle}
        angleExtent={angleExtent}
        isTrackRendered={isTrackRendered}
        thresholdDisplay={thresholdDisplay}
        indicatorSize={indicatorSize}
        {...props}
      />
    );
  }
  return (
    <SizedMeterCircle
      isReadonly={isReadonly}
      size={size || 'lg'}
      min={min}
      value={value}
      max={max}
      step={step}
      startAngle={startAngle}
      angleExtent={angleExtent}
      isTrackRendered={isTrackRendered}
      thresholdDisplay={thresholdDisplay}
      indicatorSize={indicatorSize}
      {...props}
    />
  );
}
